import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

const InsuranceCovers = ({ heading, headingText, addOnCoversList }) => {
  const classes = useStyles()
  return (
    <div className={classes.insuranceCoverContainer}>
      <div className={classes.headingSection}>
        <h2 className={classes.headingSectionTitle}>{heading}</h2>
        {headingText ? (
          <p className={classes.headingSectionText}>{headingText}</p>
        ) : null}
      </div>
      <div className={classes.addOnListContainer}>
        <div className={classes.addonListContent}>
          {addOnCoversList?.map((addOn) => {
            return (
              <div className={classes.coveragesContentItem} key={addOn?.title}>
                <div className={classes.coveragesImage}>
                  <img
                    src={addOn?.image}
                    alt=''
                    className={classes.coveragesHighlights}
                  />
                </div>

                <div className={classes.coverageContentSubTitle}>
                  {addOn?.title}
                </div>
                <div className={classes.coverageContentDescription}>
                  {addOn?.text}
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default InsuranceCovers

const useStyles = makeStyles({
  insuranceCoverContainer: {
    backgroundColor: '#E5F4F8',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 20,
    paddingTop: 6,
    paddingLeft: 90,
    paddingRight: 90,
    paddingBottom: 30,
    fontFamily: 'Roboto',
  },
  headingSection: { marginBottom: '-40px' },
  headingSectionTitle: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  addOnListContainer: { padding: '10px 4%' },
  addonListContent: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'space-around',
    // gap: 10,
  },
  coveragesContentItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    // margin: '0px 10px',
    width: '100%',
    flexBasis: '100%',

    '@media only screen and (min-width: 600px)': {
      flexBasis: '50%',
    },
    '@media only screen and (min-width: 768px)': {
      flexBasis: 'calc(100% / 3)',
    },
  },
  coveragesImage: {
    textAlign: 'center',
  },
  coveragesImageHighlights: {
    width: '130px',
  },
  coverageContentSubTitle: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    color: '#404041',
    fontWeight: 600,
    paddingBottom: '5px',
  },
  coverageContentDescription: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    textAlign: 'center',
    color: '#404041',
    lineHeight: '21.9px',
    padding: '0px 20px 20px 20px ',
  },
  headingSectionText: {
    fontFamily: 'Poppins',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '18.25px',
    color: '#404041',
  },
})
